export const permissions = {
  userDefinition: '3c3132bb-5bfa-4bb3-b82a-6a2bebe74367',
  permissionDefinition: '57812baa-944d-4da8-a8cf-2e9566e75f13',
  serviceDefinition: 'd53d6f27-3b4d-4e68-8c22-c96d41304233',
  currencyDefinition: '2f8a5880-1e59-461c-ad43-965a2a31ab6d',
  roleDefinition: '1f50d76a-b61f-4c45-a829-73fd937864d6',
  serviceTypeDefinition: 'b78f0ca2-5626-4aa6-9d9b-abf066a94135',
  documentTypeDefinition: 'a660cd79-747f-4e0d-a0ab-2c1c0d7737c2',
  statusTypeDefinition: '909a4253-f039-47fb-9316-1527c413f1cf',
  deliveryTypeDefinition: '80c1c518-7111-4b7e-be19-60aff85bd993',
  containerTypeDefinition: '281c26fd-436b-479d-8b0d-f99d424fa986',
  newReport: '139462dc-6fc4-46a8-bdd5-bb9dba745b4e',
  currentReport: '78c8dd31-d703-4867-8f94-d1ae966a5d5f',
  newReportArea: '922892f0-9617-421f-ab86-bea731edc9c9',
  currentReportArea: 'b43535ee-05cc-4389-8e64-9b6c1a48b44a',
  statusUpdate: '6dfc479e-dc61-48d6-bba8-97933f871ddc',
  taxOffice: '6a5deede-f6e2-4434-b562-60c0d35600aa',
  taxNumber: '5501c50e-aa77-4702-9682-ff0582c8854d',
  companyName: 'd505013b-7e56-40af-9b32-e5a6719f2292',
  identityNumber: 'f8b75e95-d2e6-4cca-963a-5f6b33ba4922',
  email: '8bf38e7a-2ae6-4235-9c72-261e0d219ff7',
  telephone: 'caaddb70-f321-4c3f-9dc3-de52b772d051',
  mobile: '3693f75f-41ce-45ae-a2f7-1d296c9c9b36',
  country: 'be841e42-0215-4bd1-a2dd-ab412b2e5d5f',
  city: '47ba41a5-e2f5-476c-a15c-3d0266709f42',
  districtName: '8cd66f6b-da0d-4af7-b9bb-2603dc1031ed',
  zipCode: 'a6a327ad-98f1-4a27-9df1-2f42e94adf01',
  address: '482afc86-ce55-433c-a99e-15bf78069ad2',
  allCurrents: 'ad887fd4-f6bd-408f-bb53-aa09b507a1f8',
  allShipments: '612a268c-7fba-4a01-97f0-41f0904f1141',
  newShipment: 'd677df92-0d9a-4175-a25b-b1a85b6ea457',
  shipmentReport: '9cebd1d8-8b65-4e6b-8549-4d0c8b285790',
  userReport: '8ced541b-2dc2-456c-b3c1-eae8c88534c7',
  pricesDefinition: '50f72e96-1758-404d-9077-d2055feda20a',
  bookServiceGroupDefinition: '1162b1ce-d1f7-41a9-9ac4-f69a4db02cc0',
};
